import { render, staticRenderFns } from "./transaction-card.vue?vue&type=template&id=5a9e099e&scoped=true"
import script from "./transaction-card.vue?vue&type=script&lang=js"
export * from "./transaction-card.vue?vue&type=script&lang=js"
import style0 from "./transaction-card.vue?vue&type=style&index=0&id=5a9e099e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e099e",
  null
  
)

export default component.exports